import React, { useState, useRef } from "react";
import { Table, Button, Form } from "react-bootstrap";
import { FaTrash } from "react-icons/fa";
import { IoArrowBack } from "react-icons/io5";
import { Link } from "react-router-dom";
import { updateBulkOrder } from "../../Services/orderService";
import toast from "react-hot-toast";
import { IoMdArrowRoundBack } from "react-icons/io";

const BulkUpdate = () => {

    const [orderId, setOrderId] = useState("");
    const [orders, setOrders] = useState([]);
    const [bulkStatus, setBulkStatus] = useState("");
    const [loading, setLoading] = useState(false);
    const inputRef = useRef(null);

    const handleAddOrder = () => {
        const trimmed = orderId.trim();
        if (!trimmed) return;

        if (orders.includes(trimmed)) {
            toast.warning("Order already added");
            return;
        }

        setOrders(prev => [...prev, trimmed]);
        setOrderId("");
        inputRef.current.focus();
    };

    const handleRemove = (id) => {
        setOrders(prev => prev.filter(o => o !== id));
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            handleAddOrder();
        }
    };

    const handleBulkUpdate = async () => {

        if (!bulkStatus) {
            toast.warning("Please select status");
            return;
        }

        if (!orders.length) {
            toast.warning("No orders added");
            return;
        }

        try {
            setLoading(true);

            const body = {
                trackingId: orders,
                status: bulkStatus
            };

            const response = await updateBulkOrder(body);

            console.log("API Response:", response);

            if (response?.success) {

                toast.success(
                    `${response.updatedCount} order(s) processed successfully`
                );

                setOrders([]);
                setBulkStatus("");

            } else {
                toast.error(response?.message || "Something went wrong");
            }

        } catch (error) {
            console.error(error);
            toast.error(error?.response?.data?.message || "Server error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container mt-4">

            <div className="row mb-3">

                <div className="col">

                    <div className="row g-2">
                        <div className="col-auto">
                            <Link to={"/portal/update-orders"} className="oms-icon-btn print"
                            >
                                <IoMdArrowRoundBack />

                                {/* 🖨 */}
                            </Link >
                        </div>
                        <div className="col ">
                            <h4 className="fw-semibold mb-0">
                                Bulk Status Update</h4>
                        </div>
                    </div>

                </div>

                {orders.length > 0 && (

                    <div className="col">

                        <div className="row align-items-end g-2 mb-3">

                            <div className="col">

                                <Form.Group className="">
                                    <Form.Label className="oms-label-dark">Select Status For All</Form.Label>
                                    <Form.Select
                                        className="oms-select-dark w-100"
                                        value={bulkStatus}
                                        onChange={(e) => setBulkStatus(e.target.value)}
                                    >
                                        <option value="">Select Status</option>
                                        <option value="returned">Returned</option>
                                        <option value="delivered">Delivered</option>
                                    </Form.Select>
                                </Form.Group>
                            </div>

                            <div className="col-auto">

                                <button
                                    className="oms-btn oms-btn-primary"
                                    onClick={handleBulkUpdate}
                                    disabled={!bulkStatus || loading}
                                >
                                    {loading ? "Updating..." : "Update All"}
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>




            <Form.Group className="mb-3 d-flex gap-2">
                {/* <Form.Control
                    type="text"
                    value={orderId}
                    ref={inputRef}
                    onChange={(e) => setOrderId(e.target.value)}
                    onKeyDown={handleKeyDown}
                    placeholder="Scan / Enter Order ID"
                    autoFocus
                /> */}

                <input
                    className="oms-form-input"
                    type="text"
                    value={orderId}
                    ref={inputRef}
                    onChange={(e) => setOrderId(e.target.value)}
                    onKeyDown={handleKeyDown}
                    placeholder="Scan / Enter Order ID"
                    autoFocus
                />

                <button className="oms-btn oms-btn-primary" onClick={handleAddOrder}>
                    Add
                </button>
            </Form.Group>


            {
                orders.length > 0 && (
                    <div className="oms-table-wrap">
                        <div className="oms-table-header">
                            <div>
                                <span className="oms-table-title">Order Records</span>
                                <span className="oms-table-count">{orders.length} orders</span>
                            </div>
                        </div>
                        {orders.length === 0 ? (
                            <div className="oms-empty">
                                <div className="oms-empty-icon">🔍</div>
                                <div className="oms-empty-text">No orders found</div>
                            </div>
                        ) : (
                            <div style={{ overflowX: "auto" }}>
                                <table>
                                    <thead>
                                        <tr>

                                            <th>#</th>
                                            <th>Order Id</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {orders.map((order, index) => {

                                            return (
                                                <tr key={order.id}>

                                                    {/* INDEX */}
                                                    <td>{index + 1}</td>

                                                    {/* TRACKING */}
                                                    <td>
                                                        <div className="oms-track-id">{order}</div>
                                                    </td>



                                                    {/* STATUS CHANGE DROPDOWN */}
                                                    <td>
                                                        <div className="oms-actions">


                                                            <div className="oms-icon-btn cancel" title="Cancel Order"
                                                                onClick={() => handleRemove(order)}
                                                            >
                                                                <FaTrash size={10} />
                                                            </div>


                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                )
            }



            {orders.length > 0 && (
                <>
                    <Table className="d-none" bordered hover>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Order ID</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {orders.map((item, index) => (
                                <tr key={item}>
                                    <td>{index + 1}</td>
                                    <td>{item}</td>
                                    <td className="text-center">
                                        <FaTrash
                                            style={{ cursor: "pointer", color: "red" }}
                                            onClick={() => handleRemove(item)}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>

                </>
            )}
        </div>
    );
};

export default BulkUpdate;